export default "__VITE_ASSET__7aaxUye3__"